namespace $.$$ {
	$mol_style_define( $shm_hitalama_components_tests, {
		width: '19rem', flex: { grow: 0, shrink: 0 },
		Scenario_item: {
			minWidth: 0, width: '100%', maxWidth: '100%',
			whiteSpace: 'normal', overflowWrap: 'anywhere', textAlign: 'left',
			flex: { shrink: 1 },
			'[selected]': {
				true: { color: $mol_theme.current, textShadow: '0 0' },
			},
		},
	})
}
